import { InvoiceData, InvoicesHistoryData } from "@/types";

const BASE_URL = "https://invoice-generator-worker.chkalovets55.workers.dev/invoice";

class MainApi {
    addInvoice = async (data: Omit<InvoicesHistoryData, "customerInfo" | "invoiceData">) => {
        await fetch(BASE_URL, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
    getInvoice = async (publicToken: string) => {
        const res = await fetch(`${BASE_URL}?publicToken=${publicToken}`, { method: "GET" });
        if (res.ok) {
            return await res.json() as InvoiceData;
        }
    }
    updateInvoice = async (data: Omit<InvoicesHistoryData, "customerInfo" | "invoiceData">) => {
        await fetch(BASE_URL, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
}

export const mainApi = new MainApi();